import { render } from "./Resume.vue?vue&type=template&id=1173a522&scoped=true"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=1173a522&scoped=true&lang=css"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1173a522"]])

export default __exports__